<template>
  <div class="leader-board">
    <div
      v-for="r in 4"
      :key="`row ${r}`"
      class="rows is-hidden-touch"
    >
      <div
        v-for="(c, index) in r"
        :key="`column ${index}`"
        class="columns"
      >
        <TraderCard
          :rank="(r * ( r - 1 )) / 2 + 1 + index"
          :data="topTraders[(r * ( r - 1 )) / 2 + 1 + index - 1]"
        />
      </div>
    </div>
    <div id="top-leader-board"/>
    <div
      v-for="(r, index) in shouldOpen"
      :key="r"
      class="rows is-hidden-desktop"
    >
      <TraderCard
        :rank="r"
        :data="topTraders[index]"
      />
    </div>
    <div
      class="expand-box is-hidden-desktop"
      @click="triggerSeeMore"
    >
      <span>
        {{ isExpand ? $t('exchange.see_less') : $t('exchange.see_more') }}
      </span>
      <a>
        <img
          :class="{'rotate-180deg': isExpand}"
          src="/static/svg/arrow-drop-down.svg"
        >
      </a>
    </div>
  </div>
</template>

<script>
import TraderCard from './TraderCard'

export default {
  name: 'RankingBoard',
  components: {
    TraderCard
  },
  props: {
    topTraders: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isExpand: false,
    shouldOpen: [1, 2, 3]
  }),
  methods: {
    triggerSeeMore (fact) {
      this.isExpand = !this.isExpand
      if (this.isExpand) {
        this.shouldOpen = Array.from(Array(10 + 1).keys()).slice(1)
      } else {
        this.shouldOpen = [1, 2, 3]
        this.$scrollTo('#top-leader-board', 800, { easing: 'ease-in' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.leader-board {
  display: flex;
  align-items: center;
  margin: 40px 0;
  flex-direction: column;
}
.rows {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  margin: 9px 0;
}
.columns {
  margin: 20px 0 0 28px;
}
.expand-box {
  width: 260px;
  padding: 16px 20px;
  border: 3px solid #0096ed;
  border-radius: 30px;
  color: #0096ed;
  text-align: center;
  cursor: pointer;

}
.rotate-180deg {
  transform: rotate(180deg);
}
@media screen and (max-width: 1024px){
  .leader-board {
    margin: unset;
  }
  .rows {
    margin: 15px 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/features/TopTrader/components/RankingBoard.vue